import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import fabricationImg from '../assets/images/fabrication1.jpg';
import spmImg from '../assets/images/spm.jpg';
import powerPanelImg from '../assets/images/power.jpg';
import transformerImg from "../assets/images/transformer.png";
import vacuumOvenImg from "../assets/images/vacuum-oven.png";
import sprayBoothImg from "../assets/images/spray-booth.png";
import electricalSupplyImg from "../assets/images/electrical-supply.png";

const heroSlides = [
  {
    image: fabricationImg,
    title: "Innovative Fabrication Solutions",
    subtitle: "Precision engineering for industrial excellence.",
  },
  {
    image: spmImg,
    title: "Special Purpose Machines",
    subtitle: "Custom-built machinery tailored to your needs.",
  },
  {
    image: powerPanelImg,
    title: "Power & Panel Boards",
    subtitle: "Reliable power systems & electrical distribution solutions.",
  },
  {
    image: transformerImg,
    title: "Transformers",
    subtitle: "High-performance transformers built for reliability.",
  },
  {
    image: vacuumOvenImg,
    title: "Vacuum Ovens",
    subtitle: "Advanced ovens designed for industrial applications.",
  },
  {
    image: sprayBoothImg,
    title: "Spray Painting Booths",
    subtitle: "Efficient & durable paint booth systems.",
  },
  {
    image: electricalSupplyImg,
    title: "Electrical Supplies",
    subtitle: "Complete solutions for all industrial electrical needs.",
  },
];

const HeroSection = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setCurrent((prev) => (prev + 1) % heroSlides.length),
      5000
    );
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Slide */}
      <AnimatePresence mode="wait">
        <motion.div
          key={heroSlides[current].image}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroSlides[current].image})` }}
          initial={{ opacity: 0, scale: 1.1 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
        />
      </AnimatePresence>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={heroSlides[current].title}
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -40 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <motion.h1
              className="text-4xl md:text-6xl font-bold text-white mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
            >
              {heroSlides[current].title}
            </motion.h1>

            <motion.p
              className="text-lg md:text-2xl text-gray-200 mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
            >
              {heroSlides[current].subtitle}
            </motion.p>

            <motion.div
  whileHover={{ scale: 1.1 }}
  whileTap={{ scale: 0.95 }}
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.6, duration: 0.8 }}
>
  <Link
    to="/contact"
    className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg shadow-lg inline-block"
  >
    Get in Touch
  </Link>
</motion.div>

          </motion.div>
        </AnimatePresence>
      </div>

      {/* Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3">
        {heroSlides.map((_, idx) => (
          <motion.button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-3 h-3 rounded-full ${
              current === idx ? "bg-orange-500" : "bg-gray-300"
            }`}
            whileHover={{ scale: 1.3 }}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
